/* eslint-disable */
import services from 'services';
import * as types from './mutation-types';

export default {
  fetchProductsByStore: async ({ commit }) => {
    const list = await services.ProductService.getProductsByStore();
    commit(types.SET_LIST_PRODUCT, { list: list });
  },
  setQuantityInventory: async ({ commit }, { data }) => {
    const result = await services.ProductService.setQuantityInventory(data);

    const list = await services.ProductService.getProductsByStore(data.storeId);
    commit(types.SET_LIST_PRODUCT, { list: list });
    return result;
  },
};
